var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileStoryLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 23,
  viewBox: "0 0 23 23",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M22.5 9.595c0-1.218-1.064-2-2-2H14c.467-.376 1-3.013 1-4s0-2-1-3-3.041-.621-3 .262c.039.83.256 3.617 0 4.44-.301.971-.42 1.296-1 1.975-.699.819-1.5 1.973-2.5 3.947v8.389c.313.309 1 .987 2.5 1.48l8.126-.05s2.29-.232 2.374-1.443c0-1.21-.5-1.5-.5-1.5s2-.813 2-2-.5-1.5-.5-1.5 1.5-.186 1.5-1.5c0-.604-.779-1.502-1.5-1.5.47.002 1-1 1-2M2 9.095h1.5a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2"
})));
export default SvgFacebookMobileStoryLike;